import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-compass-3-line text-base text-background-50"></i>
              </div>
              <span className="text-base font-heading font-bold text-foreground-900 whitespace-nowrap">
                性福宝导航
              </span>
            </Link>
            <p className="text-sm text-foreground-600 leading-relaxed">
              精选成人资源一站式导航平台，分类清晰、更新及时、安全可靠，帮助您快速找到所需内容。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-heading font-semibold text-foreground-900 mb-4">
              热门分类
            </h4>
            <ul className="space-y-2">
              {categories.slice(0, 5).map((cat) => (
                <li key={cat.id}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-600 hover:text-primary-600 transition-colors"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-heading font-semibold text-foreground-900 mb-4">
              常用链接
            </h4>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/"
                  className="text-sm text-foreground-600 hover:text-primary-600 transition-colors"
                >
                  首页
                </Link>
              </li>
              <li>
                <Link
                  to="/about"
                  className="text-sm text-foreground-600 hover:text-primary-600 transition-colors"
                >
                  关于我们
                </Link>
              </li>
              <li>
                <Link
                  to="/about"
                  className="text-sm text-foreground-600 hover:text-primary-600 transition-colors"
                >
                  联系我们
                </Link>
              </li>
              <li>
                <a
                  href="#"
                  className="text-sm text-foreground-600 hover:text-primary-600 transition-colors"
                >
                  隐私政策
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-heading font-semibold text-foreground-900 mb-4">
              免责声明
            </h4>
            <p className="text-sm text-foreground-600 leading-relaxed">
              本站仅为导航收录平台，所收录网站内容与本站无关。访问者需自行判断内容合法性并承担相应责任。如发现违规内容，请联系我们处理。
            </p>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-200/70 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-sm text-foreground-500">
            &copy; {currentYear} 性福宝导航 - 保留所有权利
          </p>
          <div className="flex items-center gap-4">
            <a
              href="#"
              className="text-sm text-foreground-500 hover:text-primary-600 transition-colors"
              rel="nofollow"
            >
              用户协议
            </a>
            <a
              href="#"
              className="text-sm text-foreground-500 hover:text-primary-600 transition-colors"
              rel="nofollow"
            >
              隐私政策
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}